<mat-checkbox (change)="setAll($event.checked)"  [color]="colors.primary" class="example-margin" [formControl]="formControl" [formlyAttributes]="field">{{field.templateOptions.label}}</mat-checkbox>
